module.exports = __webpack_public_path__ + "static/media/envelope-open.66d487c5.svg";